import { Aircraft } from '@models/aircraft.model';

import { mockAircraft } from '../../../mockData/aircraft';

export const getAircrafts = async (): Promise<Aircraft[]> => {
  return Promise.resolve(mockAircraft);
};

export const getAircraft = async (id: string): Promise<Aircraft> => {
  return Promise.resolve(
    mockAircraft.find(a => a.documentID === id) as Aircraft
  );
};
